module.exports = __webpack_public_path__ + "static/media/r3.a99f67e0.jpg";